module.exports = __webpack_public_path__ + "components/star-rating/static/white/9-d2526cca599c2f38a40990d16e6f2f8b.svg";